import React, { useEffect } from 'react';
import type { GetStaticPaths, GetStaticProps, NextPage} from 'next';
import fetchUtil from '../../utils/fetchUtil';
import ErrorComponent from '../../components/ErrorComponent';
import CounsellingLanding from '../../components/OnlineCounselling/counsellingLanding';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const OnlineCounciling: NextPage = (props: any) => {
    if (!props.pageData || props.pageData.length === 0) {
        return <ErrorComponent />
      }
      
    useEffect(() => {
        const customStyle = document.documentElement.style
        customStyle.setProperty('--navbar-color', '#0046c9');
        customStyle.setProperty('--navbar-menu-color', '#ffff')
      }, [])
    return (
        <>
            {props.pageData && <CounsellingLanding eventData={props.pageData[0]} />} 
        </>
    )
}
export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps = async (context) => {
    const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/online-counselling-pages?slug=${context.params?.slug}`, 'GET', {}, '', false)
    return {
        props: {
            pageData
        },
        revalidate: CACHE_REVALIDATE_24H,
    };
}

export default OnlineCounciling;